import { Box, Button, useTheme } from '@mui/material';
import { crmCustomersData } from '__fakeData__/crmCustomers';
import FlexBox from 'components/flexbox/FlexBox';
import { H6 } from 'components/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'utils/axios';
import DataTable from './DataTable';
import SearchCard from './SearchCard';

export default function UserManagement({ onUserInfoClick }) {
  const { t } = useTranslation();
  const [tableData, setTableData] = useState(crmCustomersData);
  const [filters, setFilters] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const theme = useTheme();

  const handleRowSelect = rowArr => setSelectedRows(rowArr);

  const handleSetFilter = (id, value) => {
    setFilters(prevFilters => {
      const existingFilter = prevFilters.find(f => f.id === id);

      if (!value) {
        // Remove filter if value is empty/undefined
        return prevFilters.filter(f => f.id !== id);
      }

      if (existingFilter) {
        // Update existing filter
        return prevFilters.map(f => (f.id === id ? { ...f, value } : f));
      } else {
        // Add new filter
        return [...prevFilters, { id, value }];
      }
    });
  };

  const handleClearFilters = () => {
    setFilters([]);
  };

  const ids = selectedRows.map(item => item.original.id);

  const handleDelete = async () => {
    const { data } = await axios.post('/api/tableData2/delete', {
      ids,
    });
    setTableData(data);
  };

  return (
    <Box>
      {/* Search Card */}
      <SearchCard
        filters={filters}
        setFilter={handleSetFilter}
        columns={[]}
        data={tableData}
      />

      {/* Selected Rows Actions */}
      {selectedRows.length > 0 && (
        <FlexBox alignItems="center" mb={2}>
          <H6 mr={1}>{selectedRows.length} Selected</H6>
          <Button
            size="small"
            color="error"
            variant="contained"
            onClick={handleDelete}
            sx={{
              color: 'common.white',
              borderRadius: 2,
            }}
          >
            Delete Selected
          </Button>
        </FlexBox>
      )}

      {/* Clear Filters Button */}
      {filters.length > 0 && (
        <FlexBox alignItems="center" mb={2}>
          <Button
            size="small"
            variant="outlined"
            onClick={handleClearFilters}
            sx={{
              borderRadius: 2,
            }}
          >
            Clear Filters ({filters.length})
          </Button>
        </FlexBox>
      )}

      {/* Data Table */}
      <DataTable
        data={tableData}
        externalFilters={filters}
        handleRowSelect={handleRowSelect}
        onFilterChange={() => {}}
        onUserInfoClick={onUserInfoClick}
      />
    </Box>
  );
}
